import db from '@/services/db'
import eventBus from '@/helpers/event-bus'
import contentEditorElements from '@/libs/frontwise-editor/contentEditorElements.js'
import FWTools from '@/libs/frontwise-editor/tools.js'
import toolsSortable from '@/libs/frontwise-editor/toolsSortable.js'
import toolsRTE from '@/libs/frontwise-editor/toolsRTE.js'
import gridRow from '@/libs/frontwise-editor/gridRow.js'
import gridCol from '@/libs/frontwise-editor/gridCol.js'

(function ($) {

  let FWWidget = null

  $.fn.gridEditor = function (options) {
    let self = this,
        grideditor = self.data('grideditor')

    /** Methods **/

    if (arguments[0] == 'getHtml') {
      if (grideditor) {
        grideditor.deinit()
        let html = self.html()
        grideditor.init()
        return html
      } else {
        return self.html()
      }
    }

    if (arguments[0] == 'remove') {
      if (grideditor) { grideditor.remove() } return
    }

    /** Initialize plugin */
    self.each(function (baseIndex, baseElem) {
      baseElem = $(baseElem)

      let settings = $.extend({
        'new_row_layouts': [ // Column layouts for add row buttons
          [12],
          [6, 6],
          [4, 4, 4],
          [3, 3, 3, 3],
          [2, 2, 2, 2, 2, 2],
          [2, 8, 2],
          [4, 8],
          [8, 4]
        ],
        'row_classes': [{label: 'Example class', cssClass: 'example-class'}],
        'col_classes': [{label: 'Example class', cssClass: 'example-class'}],
        'custom_filter': '',
        'content_types': ['summernote'],
        'valid_col_sizes': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        'source_textarea': ''
      }, options)

      // Elems
      let canvas,
        mainControls,
        wrapper, // controls wrapper
        addRowGroup,
        htmlTextArea

      // Copy html to sourceElement if a source textarea is given
      if (settings.source_textarea) {
        let sourceHtml = $(settings.source_textarea).val()
        if (sourceHtml.length > 0 && $('<div>' + sourceHtml + '</div>').find('.row').addBack('.row').length == 0) {
          let row = gridRow.create(),
              column = gridCol.create(12).appendTo(row)
          column.find('.ge-content').html(sourceHtml)
          sourceHtml = column.html()
        }
        baseElem.html(sourceHtml)
      }

      // Wrap content if it is non-bootstrap
      if (baseElem.children().length && !baseElem.find('div.row').length) {
        let children = baseElem.children()
        let newRow = $('<div class="row"><div class="col-lg-12"/></div>').appendTo(baseElem)
        newRow.find('.col-lg-12').append(children)
      }

      setup()
      init()

      function setup () {
        /* Setup canvas */
        canvas = baseElem.addClass('ge-canvas')

        htmlTextArea = $('<textarea class="ge-html-output"/>').insertBefore(canvas)

        /* Create main controls */
        mainControls = $('<div class="ge-mainControls" />').insertBefore(htmlTextArea)
        wrapper = $('<div class="ge-wrapper ge-top" />').appendTo(mainControls)

        // Add row
        addRowGroup = $('<div class="ge-addRowGroup btn-group" />').appendTo(wrapper)
        $.each(settings.new_row_layouts, function (j, layout) {
          let btn = $('<a class="btn btn-sm btn-primary" />')
            .attr('title', 'Add row ' + layout.join('-'))
            .on('click', function () {
              let row = gridRow.create().appendTo(canvas)
              layout.forEach(function (i) {
                gridCol.create(i).appendTo(row)
              })
              init()
              if (row[0].scrollIntoView) row[0].scrollIntoView({behavior: 'smooth'})
            })
            .appendTo(addRowGroup)

          btn.append('<i class="fa fa-plus"></i>')

          let icon = '<div class="row ge-row-icon">'
          layout.forEach(function (i) {
            icon += '<div class="column col-' + i + '"/>'
          })
          icon += '</div>'
          btn.append(icon)
        })

        // Buttons on right
        FWTools.getLayoutSelector(canvas).appendTo(wrapper)

        /** Save button into Firebase*/
        $('<div class="pull-right ge-layout-mode"><button type="button" class="btn btn-sm btn-success">Save</button></div>')
        .on('click', 'button', function () {
          $(this).attr('disabled', 'disabled')

          deinit()
          const formData = $('.widgetEditForm').serializeArray(),
                widget = Object.assign({}, FWWidget)

          $('.templateWrapper *').removeAttr('tagname').removeAttr('editselected').removeAttr('contenteditable').removeAttr('mouseon')

          widget.title = formData.find(row => row.name === 'editor-title').value || ''
          widget.template = FWTools.fixVueComponentNames(canvas.html()
            .replace(/class=""/g, '')
            .replace(/style=""/g, '')
            .replace(/class=''/g, '')
            .replace(/style=''/g, '')
            .replace('  ', ' ') || '')
          widget.styles = formData.find(row => row.name === 'editor-stylesCode').value || ''
          widget.classes = formData.find(row => row.name === 'editor-classes').value || ''
         // widget.layout = formData.find(row => row.name === 'editor-layout').value || ''
          let overflowOption = formData.find(row => row.name === 'radio-options')
          widget.overflow = overflowOption?overflowOption.value:''

          // console.log({savingFormWidget: widget, editWidgetKey: $('.widgetEditForm').attr('editWidgetKey')})

          db.widgets.update($('.widgetEditForm').attr('editWidgetKey'), widget, err => {
            eventBus.$emit('gridEditorSaved')
            $(this).removeAttr('disabled')
            if (err) console.log(err)
            init()
          })
        }).appendTo(wrapper)

        let btnGroup = $('<div class="btn-group pull-right"/>')
          .appendTo(wrapper)

        FWTools.getEditSourceCodeButton(canvas, htmlTextArea, init, deinit).appendTo(btnGroup)
        FWTools.getPreviewButton(canvas).appendTo(btnGroup)

        // Make controls fixed on scroll
        $(window).on('scroll', onScroll)

        /* Init RTE on click */
        canvas.on('click', '.ge-content', initRTE)

        /* init tag labels listener */
        let tagWrapper = document.querySelector('.templateWrapper:not(.ge-tools-rows):not(.ge-tools-cols):not(.tools)');
        if(tagWrapper) {
          tagWrapper.addEventListener(
            'mousemove',
            function(e) {
              let elem = e.target
              if ($(elem).hasClass('tools')) return
              $('[tagname]').each(function () {
                $(this).removeAttr('tagname')
              })
              elem.setAttribute('tagname', elem.tagName)
            },
            true
          )
        }

      }

      function onScroll (e) {
        var $window = $(window)

        if (
          $window.scrollTop() > mainControls.offset().top &&
          $window.scrollTop() < canvas.offset().top + canvas.height()
        ) {
          if (wrapper.hasClass('ge-top')) {
            wrapper
              .css({
                left: wrapper.offset().left,
                width: wrapper.outerWidth()
              })
              .removeClass('ge-top')
              .addClass('ge-fixed')
          }
        } else {
          if (wrapper.hasClass('ge-fixed')) {
            wrapper
              .css({left: '', width: ''})
              .removeClass('ge-fixed')
              .addClass('ge-top')
          }
        }
      }

      function reset () {
        deinit()
        init()
      }

      function init () {
        FWTools.runFilter(true, settings.custom_filter)
        canvas.addClass('ge-editing')
        gridCol.init(canvas)
        gridCol.switchLayout(0, canvas)
        /** FWTools init single tools panel */
        FWTools.init(settings)
        $(document).on('keyup', '.templateWrapper', function(e){
          switch (event.keyCode ? event.keyCode : event.which) {
            case 9: e.stopPropagation(); e.preventDefault(); break
            case 13: e.stopPropagation(); e.preventDefault(); break
            case 32: e.stopPropagation(); e.preventDefault(); break
          }
        })
        $(document).on('keypress', '.templateWrapper', function(e) {
          switch (event.keyCode ? event.keyCode : event.which) {
            case 9: document.execCommand('insertHTML', false, '&#009'); e.stopPropagation(); e.preventDefault(); break
            case 13: document.execCommand('insertHTML', false, '<br>'); e.stopPropagation(); e.preventDefault(); break
            case 32: document.execCommand('insertHTML', false, '&nbsp'); e.stopPropagation(); e.preventDefault(); break
          }
        })
      }

      function deinit () {
        $(document).off('keypress', '.templateWrapper')
        $(document).off('keyup', '.templateWrapper')
        canvas.removeClass('ge-editing')
        canvas.find('.ge-content').removeClass('ge-rte-active').each(function () {
          toolsRTE.getRTE($(this).data('ge-content-type')).deinit(settings, $(this))
        })
        canvas.find('.ge-tools-drawer').remove()
        FWTools.runFilter(false, settings.custom_filter)
        /** FWTools deinit single tools panel */
        FWTools.deinit()
      }

      function remove () {
        deinit()
        mainControls.remove()
        htmlTextArea.remove()
        $(window).off('scroll', onScroll)
        canvas.off('click', '.ge-content', initRTE)
        canvas.removeData('grideditor')
      }

      function initContentEditor (col) {
        contentEditorElements.actions.render(
          col,
          toolsRTE.getRTE(settings.content_types[0]).initialContent,
          contentEditorElements.actionAttr,
          contentEditorElements.modalId,
          contentEditorElements.templates,
          settings.updateTemplate
        );
      }

      function initRTE (e) {
        if ($(this).hasClass('ge-rte-active')) { return }
        let rte = toolsRTE.getRTE($(this).data('ge-content-type'))
        if (rte) {
          $(this).addClass('ge-rte-active', true)
          rte.init(settings, $(this))
        }
      }

      baseElem.data('grideditor', {
        init: init,
        deinit: deinit,
        remove: remove
      })
    })

    return self
  }
})(jQuery);
